<template>
  <v-card
    tile flat :ripple="false"
    class="deposit-method d-block link grey100--text"
    :class="disabled && 'is-disabled'"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <v-overlay absolute :value="loading || disabled" opacity=".8">
      <v-progress-circular v-if="loading" indeterminate />
      <span v-else v-t="'common.disabled'" class="text-uppercase text-body-2 font-weight-bold primary300--text" />
    </v-overlay>
    <v-responsive
      :aspect-ratio="2"
      class="grey700"
      content-class="d-flex align-center justify-center pa-3"
    >
      <slot name="icon" />
    </v-responsive>
    <div v-if="bonus" class="bonus-label green600 green100--text">
      +{{ bonus * 100 | toLocale }}%
    </div>
    <div v-if="!iconOnly" class="bg-ui-panel grey800 px-4 py-3">
      <h5 class="text-body-2 font-weight-semibold lh-1-3" v-text="title" />
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    bonus: {
      type: Number,
      default: null,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component() {
      if (this.$attrs.href) return 'a'
      if (this.$attrs.to) return 'router-link'
      return 'div'
    },
  },
}
</script>

<style lang="scss" scoped>
.deposit-method {
  overflow: hidden;
  position: relative;
}

.bonus-label {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 40px 5px 40px;
  font-size: 14px;
  font-weight: 900;
  line-height: 1;
  transform: rotate(30deg) translate(25%, -40%);
}

.is-disabled {
  opacity: 0.8 !important;
  cursor: not-allowed;

  > * {
    filter: grayscale(1);
  }
}
</style>
